import { render } from "./ItemUserInfoComponent.vue?vue&type=template&id=ee3bdd78&scoped=true&ts=true"
import script from "./ItemUserInfoComponent.vue?vue&type=script&lang=ts"
export * from "./ItemUserInfoComponent.vue?vue&type=script&lang=ts"

import "./ItemUserInfoComponent.vue?vue&type=style&index=0&id=ee3bdd78&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3bdd78"]])

export default __exports__